import Vue from 'vue'
import Router from 'vue-router'
import Home from '../views/Home'
import Login from '../views/login/index'

//Vue中使用router插件
Vue.use(Router)

//路由配置，配置路由路径与组件的对应关系
const routes = [
    {
        path: '/login',
        name: 'login',
        component: Login
    },
    {
        // path: '/',
        path: '/',
        name: 'home',
        component: Home
    },
    {
        path: '*',
        redirect: '/'
    }
    // {
    //     path: '/about',
    //     name: 'about',
    //     component: () => import('../views/About.vue')
    // }
]

const routesQiankun = [
    {
        path: '/',
        name: 'home',
        component: Home
    }
]

console.log('VUE_APP_BASE_API:', process.env.VUE_APP_BASE_API);
//新建路由实例
const createRouter = () => new Router({
    // scrollBehavior: () => ({ y: 0 }),
    // mode: 'history',
    //history: createWebHistory('/cloudhealth/v2/diseasemanagement/'),
    base: window.__POWERED_BY_QIANKUN__ ? '/cloudhealth/v2/cloudhealthdisease/' : '/cloudhealth/v2/diseasemanagement/',
    routes: window.__POWERED_BY_QIANKUN__ ? routesQiankun : routes
})

const router = createRouter()
// 全局前置守卫
router.beforeEach((to, from, next) => {
    console.groupCollapsed(`[路由切换] ${from.path} → ${to.path}`);
    console.log('离开的路由:', from);
    console.log('进入的路由:', to);
    console.groupEnd();

    next(); // 必须调用 next() 否则路由不会跳转
});

export const asyncRoutes = [];
export const constantRoutes = [];

export function resetRouter() {
    const newRouter = createRouter()
    router.matcher = newRouter.matcher // reset router
}

//导出路由实例，在main.js中导入使用
export default router  
